import { format as setFormat, startOfWeek, addDays } from 'date-fns';
import { DateOutput } from './type';

const buildDaysOfWeekObject = (weekStartDay: Date): Record<string, Date> => ({
  Monday: weekStartDay,
  Tuesday: addDays(weekStartDay, 1),
  Wednesday: addDays(weekStartDay, 2),
  Thursday: addDays(weekStartDay, 3),
  Friday: addDays(weekStartDay, 4),
  Saturday: addDays(weekStartDay, 5),
  Sunday: addDays(weekStartDay, 6),
  default: weekStartDay,
});

const getRequestedDay = (date: Date, day: string): Date => {
  const monday = startOfWeek(date, { weekStartsOn: 1 });
  const daysOfWeekObject = buildDaysOfWeekObject(monday);
  return daysOfWeekObject[day] || daysOfWeekObject.default;
};

const getDayOfWeek = ({
  date = new Date(),
  day = 'Monday',
  format = 'date',
}: { date?: Date; day?: string; format?: string } = {}): DateOutput => {
  if (format === 'date') return getRequestedDay(date, day);
  return setFormat(getRequestedDay(date, day), format);
};

export default getDayOfWeek;
